export const NEW_ORDER_KEY = "newOrder";
